/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getActionedSubject.defs'
export { main as default } from './getActionedSubject.defs'
